(function () {
  'use strict';

  console.log('Here in language transformation CZ -> RO');

  var ROOT_SELECTORS =
    '.cus-variant-table-wrapp, ' +
    '.blog__tag-item, ' +
    '.blog__tag-current, ' +
    '.info-box, ' +
    '.comparison-table, ' +
    '.cart-drawer, ' +
    '.collapsible-tabs-section-heading, ' +
    '.footer-link, ' +
    '.blog__post-tags-link, ' +
    '.product__selectors, ' +
    ".selected-option-value, " +
    '.navlink, ' +
    '.column-item__heading';

  // Czech/source text -> Romanian dictionary
  var dict = {
    'Schimb și returnare': '',
    'Замяна и връщане': '',
    "V případě zvláštních požadavků k objednávce nás prosím kontaktujte na emailovou adresu info@huuust.cz, nebo telefonicky na číslo +420 604 570 519.": "În cazul unor cerințe speciale privind comanda, vă rugăm să ne contactați prin e-mail la info@huuust.cz sau telefonic la +420 604 570 519.",
    'Tenkostěnná litina':
      'Fontă cu pereți subțiri',

    'Představujeme netoxické materiály':
      'Vă prezentăm materiale non-toxice',

    'След като стойността на поръчката ви достигне 3500 чешки крони, доставката е безплатна.':
      'Pentru comenzile de cel puțin 145 EUR, livrarea este gratuită.',

    'Nepřilnavost':
      'Proprietăți antiaderente',

    'Titanový smalt je oproti běžnému smaltu výrazně nepřilnavější. Nerez bez povlaku má horší nepřilnavost.':
      'Emailul cu titan are proprietăți antiaderente semnificativ mai bune decât emailul obișnuit. Oțelul inoxidabil fără strat de acoperire are proprietăți antiaderente mai slabe.',

    'Tepelná vodivost':
      'Conductivitate termică',

    'Jak rychle a rovnoměrně se materiál zahřívá - nerez s hliníkovým jádrem je nejeefektivnější.':
      'Cât de repede și uniform se încălzește materialul – oțelul inoxidabil cu miez din aluminiu este cel mai eficient.',

    'Udržení teploty':
      'Menținerea temperaturii',

    'Schopnost materiálu držet teplotu – důležité při dušení a servírování. Litina vyniká.':
      'Capacitatea materialului de a menține temperatura – importantă pentru gătirea lentă și servire. Fonta excelează la acest capitol.',

    'Odolnost proti poškození. Smalt se může odštípnout, titanový smalt je pevnější. Nerez se může lehce deformovat.':
      'Rezistență la deteriorare. Emailul se poate ciobi, însă emailul cu titan este mai rezistent. Oțelul inoxidabil se poate deforma ușor.',

    'Snadnost údržby':
      'Ușurința întreținerii',

    'Možnost mytí v myčce. Nerez je bez problémů, litinu doporučujeme mýt ručně.':
      'Posibilitatea spălării în mașina de spălat vase. Oțelul inoxidabil poate fi spălat fără probleme, însă pentru fontă recomandăm spălarea manuală.',

    'Indukce':
      'Inducție',

    'Odolnost':
      'Rezistență',

    'Kompatibilita s indukcí – všechny tři materiály jsou vhodné.':
      'Compatibilitate cu plitele cu inducție – toate cele trei materiale sunt potrivite.',

    'Hmotnost a manipulace – tenká litina je o 50 % lehčí než klasická, nerez nejlehčí.':
      'Greutate și manevrare – fonta cu pereți subțiri este cu 50% mai ușoară decât fonta clasică, iar oțelul inoxidabil este cel mai ușor.',

    'Průměr dna':
      'Diametrul bazei',

    'Design od':
      'Design realizat de',

    'NÁDOBÍ S DNA':
      'VASE CU ADN DIN INDUSTRIA',

    'AUTOMOTIVE':
      'AUTO',

    'OVĚŘENO':
      'TESTAT DE',

    'ŠÉFKUCHAŘI':
      'BUCĂTARI PROFESIONIȘTI',

    'Průměr okrajů':
      'Diametrul marginii',

    'Rozměry':
      'Dimensiuni',

    'Objem':
      'Volum',
    "Huuust oranžová": "Portocaliu Huuust",
"Matná černá": "Negru mat",
"Perlově šedá": "Gri perlat",
"Granátově červená": "Roșu granat",
"Safírově modrá": "Albastru safir",
"Pastelově modrá": "Albastru pastel",
"Pastelově žlutá": "Galben pastel",
"Pastelově oranžová": "Portocaliu pastel",
    'Hmotnost':
      'Greutate',

    'Barva':
      'Culoare',

    'Materiál':
      'Material',

    'Litina':
      'Fontă',

    'Plody moře':
      'Fructe de mare',

    'Dárky':
      'Cadouri',

    'Inspirace':
      'Inspirație',

    'Non-toxic':
      'Non-toxic',

    'Udržitelnost':
      'Sustenabilitate',

    'Nerezové nádobí':
      'Vase din oțel inoxidabil',

    'Nože':
      'Cuțite',

    'Smaltované nádobí':
      'Vase emailate',

    'Tipy':
      'Sfaturi',

    'Zajímavosti':
      'Informații interesante',

    'Dezert':
      'Desert',

    'Dušení':
      'Gătire lentă',

    'Hovězí':
      'Carne de vită',

    'Kuřecí':
      'Carne de pui',

    'Ovoce':
      'Fructe',

    'Pečení':
      'Coacere',

    'Smažení':
      'Prăjire',

    'Vaření':
      'Gătit',

    'Vepřové':
      'Carne de porc',

    'Zelenina':
      'Legume',

    'kategorie':
      'Categorie',

    'Images':
      'Imagini',

    'Dostupnost':
      'Disponibilitate',

    'Google: Condition':
      'Google: Stare',

    'Google: MPN':
      'Google: MPN',

    'Google: Gender':
      'Google: Gen',

    'Google: Size Type':
      'Google: Tipul mărimii',

    'Google: Size System':
      'Google: Sistemul de mărimi',

    'Google: Age Group':
      'Google: Grupă de vârstă',

    'Poklice součástí balení':
      'Capacul este inclus în pachet',

    'Google: Custom Label 0':
      'Google: Etichetă personalizată 0',

    'Google: Custom Label 1':
      'Google: Etichetă personalizată 1',

    'Google: Custom Label 2':
      'Google: Etichetă personalizată 2',

    'Google: Custom Label 3':
      'Google: Etichetă personalizată 3',

    'Objednáš, vyzkoušíš, v klidu vrátíš':
      'Comanzi, încerci și returnezi fără griji',

    'Další informace':
      'Mai multe informații',

    'Vlastnost':
      'Caracteristică',

    'Vysvětlivka':
      'Explicație',

    'Zahřívání':
      'Încălzire',

    'Reakce na teplotu':
      'Reacție la schimbările de temperatură',

    'Údržba':
      'Întreținere',

    'Použití':
      'Utilizare',

    'Pro koho je':
      'Potrivit pentru',

    'Surová litina':
      'Fontă neemailată',

    'Těžší, robustní':
      'Mai grea și robustă',

    'Zahřívá se pomaleji':
      'Se încălzește mai lent',

    'Pomalejší změny':
      'Schimbări mai lente de temperatură',

    'Často vyžaduje více péče':
      'Necesită adesea mai multă întreținere',

    'Skvělé na dlouhé dušení a pečení':
      'Excelentă pentru gătire lentă și coacere îndelungată',

    'Pro milovníky tradiční litiny a pomalého vaření':
      'Pentru iubitorii fontei tradiționale și ai gătitului lent',

    'Lehčí, snadnější manipulace':
      'Mai ușoară și mai simplu de manevrat',

    'Zahřívá se rychleji':
      'Se încălzește mai repede',

    'Pohotovější při vaření':
      'Reacționează mai rapid în timpul gătitului',

    'Bez seasoning a bez rituálů':
      'Nu necesită asezonare și nici ritualuri speciale de întreținere',

    'Индукция i trouba, ideální i na každý den':
      'Potrivită pentru inducție și cuptor, ideală pentru utilizarea zilnică',

    'Pro každodenní vaření i náročnější recepty':
      'Pentru gătitul zilnic și pentru rețete mai complexe',
      "Součet": "Total",
      "Celkově ušetřeno": "Economii totale"
  };

  var keys = Object.keys(dict);

  function replaceInTextNode(node) {
    var text = node.nodeValue;

    if (!text) {
      return;
    }

    var changed = false;

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (text.indexOf(key) !== -1) {
        text = text.split(key).join(dict[key]);
        changed = true;
      }
    }

    if (changed) {
      node.nodeValue = text;
    }
  }

  function walkAndReplace(container) {
    var walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) {
            return NodeFilter.FILTER_REJECT;
          }

          var parent = node.parentNode;

          if (!parent) {
            return NodeFilter.FILTER_REJECT;
          }

          var tag = (parent.nodeName || '').toLowerCase();

          if (
            tag === 'script' ||
            tag === 'style' ||
            tag === 'noscript'
          ) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var node;

    while ((node = walker.nextNode())) {
      replaceInTextNode(node);
    }
  }

  function run() {
    // Re-query the elements because Shopify may inject them later.
    var roots = document.querySelectorAll(ROOT_SELECTORS);

    if (!roots.length) {
      return;
    }

    roots.forEach(function (element) {
      walkAndReplace(element);
    });
  }

  // Run once after the DOM is ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Observe dynamic updates inside the matching Shopify elements.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.type === 'characterData') {
        replaceInTextNode(mutation.target);
      } else if (
        mutation.addedNodes &&
        mutation.addedNodes.length
      ) {
        for (
          var j = 0;
          j < mutation.addedNodes.length;
          j++
        ) {
          var addedNode = mutation.addedNodes[j];

          if (addedNode.nodeType === 3) {
            replaceInTextNode(addedNode);
          } else if (addedNode.nodeType === 1) {
            walkAndReplace(addedNode);
          }
        }
      }
    }
  });

  function startObserver() {
    var roots = document.querySelectorAll(ROOT_SELECTORS);

    if (!roots.length) {
      return false;
    }

    roots.forEach(function (element) {
      observer.observe(element, {
        subtree: true,
        childList: true,
        characterData: true
      });
    });

    return true;
  }

  if (!startObserver()) {
    // Retry briefly for content loaded after initial rendering.
    var tries = 0;

    var timer = setInterval(function () {
      tries++;
      run();

      if (startObserver() || tries > 20) {
        clearInterval(timer);
      }
    }, 500);
  }
})();